'use client'

import { isNull } from 'lodash-es'
import { useCallback, useRef, useState } from 'react'

export const useScrollTopDetector = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const rafRef = useRef<number | null>(null)

  const [isScrolled, setIsScrolled] = useState(false)

  const onScroll = useCallback(() => {
    const element = ref.current

    if (!element) return

    if (!isNull(rafRef.current)) {
      cancelAnimationFrame(rafRef.current)
    }

    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null
      setIsScrolled(element.scrollTop > 0)
    })
  }, [])

  const scrollToTop = useCallback(
    ({ behavior = 'instant' }: ScrollToOptions = {}) => {
      ref.current?.scrollTo({ top: 0, behavior })
    },
    [],
  )

  return { ref, isScrolled, scrollToTop, onScroll }
}
